import { SectionInterface, StoreWallInterface } from "../../types/store";
import { updateShelfRodIds } from "../../helpers/updateShelfRodIds";

const replaceItems = (section: SectionInterface, diffOffsetWidth: number) => {
    if (section.items.length !== 0) {
        return section.items.map((item) => {
            item.position = [item.position[0] + diffOffsetWidth, item.position[1], item.position[2]];
            return item;
        });
    } else {
        return [];
    }
};
interface updateSectionInterface {
    currentShelving: StoreWallInterface;
    newSection: SectionInterface;
}

export const getUpdateSections = ({ currentShelving, newSection }: updateSectionInterface) => {
    const newCurrentShelving = structuredClone(currentShelving);
    const replaceSectionIndex = newCurrentShelving.sections.findIndex((section) => section.id === newSection.id);
    const oldSection = newCurrentShelving.sections[replaceSectionIndex];
    if (!oldSection) {
        console.error("getUpdateSections ни чего не нашёл.");
        return;
    }
    const diffOffsetWidth = newSection.width - oldSection.width; //Новый отступ секциям справа

    const resizedSections = newCurrentShelving.sections.map((section, index) => {
        /**
         * Текущая секция (изменение высоты правой стойки в текущей секции)
         */
        if (index === replaceSectionIndex) {
            return { ...newSection };
        }
        /**
         * Предыдущая секция (изменение высоты левой стойки в текущей секции)
         */
        if (index === replaceSectionIndex - 1) {
            return { ...section, height: newSection.leftRackHeight };
        }
        /**
         * Следующая секция (изменение высоты левой стойки в следующей секции)
         */
        if (index === replaceSectionIndex + 1) {
            const items = replaceItems(section, diffOffsetWidth / 1000);
            return { ...section, items, leftRackHeight: newSection.height, offset: section.offset + diffOffsetWidth };
        }
        /**
         * Предыдущие секции не изменяем
         */
        if (index < replaceSectionIndex) {
            return section;
        }
        /**
         * Добавление отступа секциям справа от редактируемой секции
         */
        section.items = replaceItems(section, diffOffsetWidth / 1000);
        return { ...section, offset: section.offset + diffOffsetWidth };
    });

    const newSections = resizedSections;

    // Обновляем штанги в частях полок после изменения секций
    const hasShelfRods = newSections.some(section => 
        section.items.some(item => 
            item.parts.some(part => part.type?.some((t) => t === "Штанга"))
        )
    );
    
    if (hasShelfRods) {
        return updateShelfRodIds(newSections);
    }
    
    return newSections;
};
